import React from 'react';
import { Col, Form, Row, Switch } from 'antd';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { settingShape } from '../../../../../services/repository/settingRepository/objects/setting';
import InfoPopover from '../../atoms/InfoPopover';

const FieldVisibilityColumn = styled(Col)`
  padding-bottom: 5px;
`;

function FieldsVisibility({ settings, onChange }) {
  const FormLabel = (
    <span>
      <b>Itens Visíveis</b>
      <InfoPopover
        placement="right"
        content="Desativar um dos itens irá esconder a visualização do mesmo no simulador e o item não será válido durante o cálculo"
      />
    </span>
  );
  return (
    <Form.Item label={FormLabel}>
      <Row gutter={24}>
        {Object.entries(settings).map(([key, { label, valueType, value }]) => (
          <FieldVisibilityColumn xs={12} sm={8} md={6} lg={6} xl={6} key={key}>
            <span>{label}</span>
            <br />
            <Switch
              id={key}
              checked={value}
              onChange={(changedValue) =>
                onChange(key, valueType, changedValue)
              }
            />
          </FieldVisibilityColumn>
        ))}
      </Row>
    </Form.Item>
  );
}

FieldsVisibility.propTypes = {
  settings: PropTypes.shape(settingShape).isRequired,
  onChange: PropTypes.func.isRequired,
};

export default FieldsVisibility;
